module.exports = __webpack_public_path__ + "static/media/angle-left.e2d72838.svg";